// pages/Caravan.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function CaravanENG() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="caravan-page">
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

        <style jsx>{`
          @media (max-width: 768px) {
            .caravan-page > div:nth-child(1) {
              padding: 60px 0 30px !important;
              min-height: 300px !important;
            }
            .caravan-page h1 {
              font-size: 2.5rem !important;
            }
            .caravan-page h3 {
              font-size: 1.5rem !important;
            }
          }
        `}</style>
      <img
src="/images/Asset4.png"
alt="Mapping Icon"
style={{
 width: '80px',
 height: '80px',
 objectFit: 'contain'
}}
/>
        <h1 style={{
          fontSize: '3.5rem',
          marginBottom: '20px',
          background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          Caravan of rights against violence
        </h1>
        <p style={{
          fontSize: '1.3rem',
          lineHeight: '1.9',
          marginBottom: '25px',
          color: 'var(--text-light)',
        direction:'ltr'        }}>
        An itinerant caravan journeying through all 12 regions of Morocco to break silence.
        </p>
        <div style={{
          background: 'var(--secondary-black)',
          padding: '20px 30px',
          borderRadius: '15px',
          borderLeft: '4px solid var(--primary-orange)',
          marginBottom: '25px',   direction:'ltr'
        }}>
          <p style={{ fontSize: '1.3rem', marginBottom: '10px', textAlign: 'center' }}>
              <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong>Departure date:</strong> Tuesday, November 25, 2025
          </p>
          <p style={{ fontSize: '1.3rem', textAlign: 'center' }}>
            <img src="/images/location.png" className="tab-icon3-img" /> <strong>Number of cities:</strong> 12 cities
          </p>
        </div>
        </div>
      </div>

      {/* Main Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container">


          {/* Mission & Objectives */}
          <div style={{ marginBottom: '60px' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              Objectives
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              marginBottom: '40px',
              direction:'ltr'
            }}>
              {[
                {
                  icon: '🤝',
                  title: 'Interaction and dialogue',
                  desc: 'Connecting with citizens across Moroccan regions to raise awareness about digital violence against women and girls.'
                },
                {
                  icon: '👂',
                  title: 'Listening and engagement',
                  desc: 'Listening to citizens and to survivor stories with digital violence.'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  transition: 'all 0.3s ease',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '3rem', marginBottom: '15px' }}>{item.icon}</div>
                  <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Cities Itinerary */}
          <div style={{ marginTop: '60px', marginBottom: '60px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '20px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              🗺️ Caravan itinerary across Morocco
            </h3>
            <p style={{
              textAlign: 'center',
              fontSize: '1.2rem',
              marginBottom: '40px',
              color: 'var(--text-light)',
              direction:'ltr'

            }}>
            12 regions | 16 days | From the south of the Kingdom to the north
            </p>

            <div style={{
              display: 'grid',
              gap: '20px',   direction:'ltr'
            }}>
              {[
  { city: 'Dakhla', region: 'Dakhla–Oued Eddahab', dates: 'November 27', day: 'Stop 1', icon: '/images/ville/Dakhla.png' },
  { city: 'Laayoune', region: 'Laayoune–Sakia El Hamra', dates: 'November 29', day: 'Stop 2', icon: '/images/ville/Laayoun.png' },
  { city: 'Guelmim', region: 'Guelmim–Oued Noun', dates: 'November 30', day: 'Stop 3', icon: '/images/ville/Orientale.png' },
  { city: 'Agadir', region: 'Souss-Massa', dates: 'December 1', day: 'Stop 4', icon: '/images/ville/Agadir.png' },
  { city: 'Benguerir', region: 'Marrakech–Safi', dates: 'December 2', day: 'Stop 5', icon: '/images/ville/Marrakech.png' },
  { city: 'Ouarzazate', region: 'Draa–Tafilalet', dates: 'December 3', day: 'Stop 6', icon: '/images/ville/Tafilalt.png' },
  { city: 'Beni Mellal', region: 'Beni Mellal–Khenifra', dates: 'December 5', day: 'Stop 7', icon: '/images/ville/Benimellal.png' },
  { city: 'Casablanca', region: 'Casablanca–Settat', dates: 'December 6', day: 'Stop 8', icon: '/images/ville/Casa.png' },
  { city: 'Fez', region: 'Fez–Meknes', dates: 'December 7', day: 'Stop 9', icon: '/images/ville/Meknes.png' },
  { city: 'Oujda', region: 'Oriental', dates: 'December 8', day: 'Stop 10', icon: '/images/ville/Orientale.png' },
  { city: 'Al Hoceima', region: 'Tangier–Tetouan–Al Hoceima', dates: 'December 9', day: 'Stop 11', icon: '/images/ville/Tanger.png' },
  { city: 'Kenitra', region: 'Rabat-Salé–Kénitra', dates: 'December 10', day: 'Stop 12', icon: '/images/ville/Rabat.png' }
].map((stop, index) => (
                <div key={index} className="city-card" style={{
                  background: index % 2 === 0 ? 'var(--primary-black)' : 'var(--secondary-black)',
                  padding: '25px 30px',
                  borderRadius: '15px',
                  border: '2px solid rgba(255, 107, 53, 0.3)',
                  display: 'grid',
                  gridTemplateColumns: '80px 1fr 200px 150px',
                  alignItems: 'center',
                  gap: '20px',
                  transition: 'all 0.3s ease'
                }}>
                  <div className="city-icon" style={{
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <img
                      src={stop.icon}
                      alt={stop.city}
                      style={{
                        width: '60px',
                        height: '60px',
                        objectFit: 'contain'
                      }}
                    />
                  </div>

                  <div className="city-info" style={{ textAlign: 'left' }}>
                    <h4 style={{
                      fontSize: '1.5rem',
                      marginBottom: '5px',
                      color: 'var(--primary-orange)',
                      fontWeight: '700'
                    }}>
                      {stop.city}
                    </h4>
                    <p style={{
                      fontSize: '1.1rem',
                      color: 'var(--text-light)'
                    }}>
                      {stop.region}
                    </p>
                  </div>

                  <div className="city-date" style={{
                    background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
                    padding: '12px 20px',
                    borderRadius: '10px',
                    textAlign: 'center',
                    fontWeight: '700',
                    fontSize: '1.1rem'
                  }}>
                    {stop.dates}
                  </div>

                  <div className="city-day" style={{
                    textAlign: 'center',
                    fontSize: '1rem',
                    color: 'var(--text-light)',
                    fontWeight: '600'
                  }}>
                    {stop.day}
                  </div>
                </div>
              ))}
            </div>

            {/* Responsive Styles */}
            <style jsx>{`
              @media (max-width: 768px) {
                .city-card {
                  grid-template-columns: 1fr !important;
                  padding: 20px 15px !important;
                  gap: 15px !important;
                  text-align: center;
                }

                .city-icon {
                  margin-bottom: 10px;
                }

                .city-icon img {
                  width: 50px !important;
                  height: 50px !important;
                }

                .city-info {
                  text-align: center !important;
                }

                .city-info h4 {
                  font-size: 1.3rem !important;
                  margin-bottom: 8px !important;
                }

                .city-info p {
                  font-size: 1rem !important;
                  line-height: 1.5;
                }

                .city-date {
                  margin: 10px auto !important;
                  max-width: 200px;
                  padding: 10px 15px !important;
                  font-size: 1rem !important;
                }

                .city-day {
                  font-size: 0.95rem !important;
                  padding-top: 5px;
                }
              }

              @media (max-width: 480px) {
                .city-card {
                  padding: 15px 10px !important;
                }

                .city-info h4 {
                  font-size: 1.2rem !important;
                }

                .city-info p {
                  font-size: 0.95rem !important;
                }

                .city-date {
                  font-size: 0.95rem !important;
                  padding: 8px 12px !important;
                }
              }
            `}</style>
          </div>

          <div className="section-separator"></div>




          {/* Call to Action */}
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)'
            }}>
              Join this national journey
            </h3>
            <p style={{
              fontSize: '1.3rem',
              marginBottom: '30px',
              color: 'var(--text-light)',
              lineHeight: '1.8'
            }}>
              Come meet us at the 12 stops across Morocco
            </p>



            <p style={{
              fontSize: '1.2rem',
              marginTop: '30px',
              color: 'var(--text-light)',
              fontStyle: 'italic',   direction:'ltr'
            }}>
              Your voices, ideas, and experiences matter, and we're here to listen.
            </p>
          </div>
        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default CaravanENG;
